<template>
  <div style="height: calc(100% - 60px)" id="course_menu">
    <div class="header">
      <div @click="handleClickLogo">
        <img src="@/img/logo_course.png" height="30" alt />
      </div>
      <div>
        <div>
          <img src="@/img/touxiang.png" alt />
          <span>{{ user.xm }}</span>
        </div>
        <!-- <div>
          <img src="@/img/tuichu.png" alt />
          <span>退出</span>
        </div> -->
      </div>
    </div>

    <el-row style="height: 100%; background-color: rgb(245, 245, 245)">
      <el-col :span="3" style="height: 100%; overflow-y: auto">
        <el-menu
          :default-active="activeMenu"
          class="el-menu"
          :collapse-transition="true"
          mode="vertical"
          :unique-opened="true"
          :collapse="isCollapse"
        >
          <sidebar-item
            v-for="(route, index) in myMenu"
            :key="route.path"
            :item="route"
            :base-path="route.path"
            :index="index"
          />
        </el-menu>
      </el-col>
      <el-col id="rignt-content" :span="21" style="height: 100%">
        <div class="rignt-wrap"><router-view></router-view></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "../../layout/components/Sidebar/SidebarItem";
import { getMenuList } from "@/api/course.js";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["user"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      if (path.indexOf("approveDetail") > 0) {
        return path.replace("/approveDetail", "");
      }
      return path;
    },
  },
  data() {
    return {
      isCollapse: false,
      myMenu: [
        {
          title: "首页",
          url: "/course/index",
          children: [],
          distinguish: "4",
          icon: "",
          parentId: 176,
        },
        {
          title: "课题列表",
          url: "/course/courseList",
          children: [],
          distinguish: "4",
          icon: "",
          parentId: 176,
        },
        {
          title: "评委导师管理",
          url: "course/judges",
          children: [],
          distinguish: "4",
          icon: "",
          parentId: 176,
        },
        {
          title: "课题统计",
          url: "/course/courseCharts",
          children: [],
          distinguish: "4",
          icon: "",
          parentId: 176,
        },
        {
          title: "课题阶段配置",
          url: "/course/courseArrange",
          children: [],
          distinguish: "4",
          icon: "",
          parentId: 176,
        },
        {
          title: "文件模板管理",
          url: "/course/courseFile",
          children: [],
          icon: "",
          parentId: 176,
        },
        {
          title: "表单模板管理",
          url: "/course/courseMeta",
          children: [],
          distinguish: "4",
          icon: "",
          parentId: 176,
        },
      ],
    };
  },
  created() {
    getMenuList().then((res) => {
      if (res.code == 0) {
        this.myMenu = this.filterRoutes("", [], res.data);
      }
    });
    // this.myMenu = this.filterRoutes("", [], this.myMenu);
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction");
    }
  },
  methods: {
    urlFun(path) {
      this.$router.push(path);
    },
    filterRoutes(root, routers, data) {
      if (!data && data.length == 0) {
        return;
      }
      const keyMap = {
        url: "path",
      };
      // data[i].url 转为 data[i].path
      for (var i = 0; i < data.length; i++) {
        var obj = data[i];
        for (var key in obj) {
          var newKey = keyMap[key];
          if (newKey) {
            obj[newKey] = obj[key];
            delete obj[key];
          }
        }
      }
      data.forEach((item) => {
        const obj = {
          path: item.path,
          component: () => import(`@/views/${item.icon}/index`),
          name: "menu_" + item.icon,
          meta: {
            title: item.title,
            icon: item.icon,
            roles: ["admin"],
          },
          children: [],
        };
        if (item.children) {
          this.filterRoutes(obj.path, obj.children, item.children);
        }
        routers.push(obj);
      });
      return routers;
    },
    handleClickLogo() {
      this.$router.push("/course/index");
    },
  },
};
</script>
<style >
.el-submenu__title {
  background: #fff;
}
.el-menu-item {
  background-color: #fff;
  color: #333;
}
#course_menu a {
  text-decoration: none;
}
.menubar {
  background-color: #fff;
}
</style>
<style lang="less" scoped>
.el-menu {
  margin: 10px 0 10px 10px;
  height: calc(100% - 20px);
  background-color: #fff;
  border-right: 0;
  border-radius: 6px;
  overflow: hidden;
}

#rignt-content {
  overflow-y: auto;
  padding: 10px;
}
.rignt-wrap {
  border-radius: 6px;
  background-color: #fff;
  min-height: 100%;
  padding: 10px;
  box-sizing: border-box;
}
div::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  /**/
}
div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #333;
}
div::-webkit-scrollbar-corner {
  background: #179a16;
}
</style>
<style lang="less" scoped>
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px 10px 0 10px;
  background-color: #fff;
  border-radius: 6px;
}
.el-form-item {
  margin-bottom: 10px;
}
.zdy .el-form-item {
  margin-bottom: 5px;
}
.fixed-width .el-button--mini {
  width: auto;
  padding: 7px 2px;
}
.el-button + .el-button {
  margin-left: 0;
}
</style>
<style lang="less" >
.header {
  background-color: #2f4050;
  height: 60px;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  color: #fff;
  font-size: 15px;
  border-bottom: 1px solid #7f7f7f;
  > div:nth-of-type(1) {
    img {
      cursor: pointer;
    }
  }
  > div:nth-of-type(2) {
    display: flex;
    img {
      height: 20px;
      margin-top: 10px;
      margin-right: 10px;
    }
    div {
      margin-right: 15px;
      display: flex;
    }
    div:nth-of-type(2) {
      cursor: pointer;
    }
  }
}
.el-popover ul {
  padding: 10px 0 0 10px;
}
.el-popover p {
  margin: 5px 0;
  color: #999;
}
.el-timeline-item__timestamp {
  color: #000;
  font-weight: bold;
}

.el-timeline-item {
  padding-bottom: 10px;
}
.el-timeline-item__node--normal,
.el-timeline-item__node--large {
  width: 18px;
  height: 18px;
}
.el-card__body {
  padding: 5px 10px;
}
.el-popover,
.el-card.is-always-shadow {
  box-shadow: 0px 3px 27px 3px rgba(22, 114, 200, 0.1);
}
</style>